/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Featurechartsdescription2Inputs */

const he_extension_featurechartsdescription2 = /** @type {(inputs: Extension_Featurechartsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צפו בגרפים מפורטים של היסטוריית מחירים עם ניתוח מגמות מתקדם`)
};

const en_extension_featurechartsdescription2 = /** @type {(inputs: Extension_Featurechartsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View detailed price history charts with advanced trend analysis`)
};

/**
* | output |
* | --- |
* | "View detailed price history charts with advanced trend analysis" |
*
* @param {Extension_Featurechartsdescription2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_featurechartsdescription2 = /** @type {((inputs?: Extension_Featurechartsdescription2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Featurechartsdescription2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_featurechartsdescription2(inputs)
	return en_extension_featurechartsdescription2(inputs)
});
export { extension_featurechartsdescription2 as "extension_featureChartsDescription" }